import { Coordinates, Location } from '../types/location';

export function useGeolocation(
    markers: Location[],
    setMarkers: (markers: Location[]) => void,
    setCurrentLocation: (loc: Location) => void,
    showModal: (coords: Coordinates) => void,
) {
    function createCurrentPositionMarker() {
        if (!navigator.geolocation) {
            console.error("Geolocation is not supported by this browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;

                setMarkers([...markers, { latitude, longitude } as Location]);
                setCurrentLocation({ latitude, longitude });
                showModal({ lat: latitude, long: longitude });
            },
            (error) => console.error(error),
        );
    }

    return { createCurrentPositionMarker };
}
